import type { SegmentMst } from '@libs/domain';
import { MstRegistration, MstRegistrationRaw } from '@libs/templates/mst';

class SegmentMstRegistration
  extends MstRegistration
  implements Pick<SegmentMst['schema'], 'higherRankSegmentCode'>
{
  private constructor(
    mstRegistration: MstRegistration,
    readonly higherRankSegmentCode: string,
  ) {
    super(
      mstRegistration.id,
      mstRegistration.version,
      mstRegistration.code,
      mstRegistration.name,
      mstRegistration.mstSpareName01,
      mstRegistration.mstSpareName02,
      mstRegistration.validityStartDate,
      mstRegistration.validityEndDate,
      mstRegistration.mstNote,
    );
  }

  static init(code?: string) {
    return new SegmentMstRegistration(MstRegistration.baseInit(code), '');
  }

  static fromRaw(raw: SegmentMstRegistrationRaw) {
    return new SegmentMstRegistration(MstRegistration.baseFromRaw(raw), raw.higherRankSegmentCode);
  }
}

class SegmentMstRegistrationRaw
  extends MstRegistrationRaw
  implements Pick<SegmentMst['record'], 'higherRankSegmentCode'>
{
  private constructor(
    mstRegistrationRaw: MstRegistrationRaw,
    readonly higherRankSegmentCode: string,
  ) {
    super(
      mstRegistrationRaw.id,
      mstRegistrationRaw.version,
      mstRegistrationRaw.code,
      mstRegistrationRaw.name,
      mstRegistrationRaw.mstSpareName01,
      mstRegistrationRaw.mstSpareName02,
      mstRegistrationRaw.validityStartDate,
      mstRegistrationRaw.validityEndDate,
      mstRegistrationRaw.mstNote,
    );
  }

  static fromModel(segmentMstRegistration: SegmentMstRegistration) {
    return new SegmentMstRegistrationRaw(
      MstRegistrationRaw.baseFromModel(segmentMstRegistration),
      segmentMstRegistration.higherRankSegmentCode,
    );
  }
}

export { SegmentMstRegistration, SegmentMstRegistrationRaw };
